import { useTracking } from '../../../hooks';
import { ExternalScriptTestIds } from '../types';

export const Sovendus = ({
  type = 'default',
  containerId = 'sovendus-container-1',
}: {
  type?: 'default' | 'newsletterSuccess';
  containerId?: string;
}) => {
  const dispatchGTMEvent = useTracking();

  dispatchGTMEvent({
    event: 'renderSovendusScript',
    sovendusType: type,
    sovendusContainerId: containerId,
  });

  return <div id={containerId} data-testid={ExternalScriptTestIds.SovendusScript} />;
};
